<template>
  <!-- <div v-if="message_id != null && !notFeedback && notFeedback != true"> -->
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Retroalimentación respuesta'"
      />
      <div class="form-box-body">
        <div class="form-components scroll">
          <div
            class="form_label"
            v-text="'Ingresa tu Nombre y Apellido *'"
          />
          <div class="form__field">
            <label
              for="nombre"
            ><v-icon
              name="user"
              scale="1"
              style="margin: 1px 1px 0"
            /></label>
            <input
              id="nombre"
              ref="nombre"
              v-model="nombre"
              autocomplete="off"
              type="text"
              name="nombre"
              value=""
              placeholder=""
              required
              @focus="_clearError"
              @keyup.enter="focusTo('pass')"
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @change="cleanSpecialChars('nombre', 'name')"
            >
          </div>
          <!-- TEXTAREA -->

          <div class="form_label">
            ¿Por qué le pareció mala la respuesta?
          </div>
          <br>
          <div class="score-comments">
            <textarea
              v-model="motivo"
              placeholder="La respuesta no me parece adecuada porque..."
            />
          </div>
          <br>
          <div class="form_label">
            ¿Cuál respuesta sería más acorde?
          </div>
          <br>
          <div class="score-comments">
            <textarea
              v-model="sugerencia"
              placeholder="Sería más claro una respuesta tal como..."
            />
          </div>
        </div>

        <!-- BOTONES -->
        <div class="form-box-button scroll margin_btn">
          <button
            class="button-secondary"
            @click="_cancelClick"
          >
            Cancelar
          </button>
          <button
            class="button-primary"
            @click="_sentClick"
          >
            Enviar
          </button>
        </div>
      </div>

      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
  <!-- </div>   -->
</template>

<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/shipping-fast'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {
    message: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      // message_id : this.message._id,
      title: '',
      errormsg: '',
      nombreOrigen: '',
      nombre: '',
      motivo: '',
      sugerencia: '',
      chat_log_id: ''
    }
  },
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'NegativeFeedbackForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:", e.dato);
        this.title = e.dato.title ? e.dato.title : 'Retroalimentación negativa'
        this.nombreOrigen = e.dato.chat_user_name
          ? e.dato.chat_user_name
          : 'Visita'
        this.motivo = e.dato.motivo ? e.dato.motivo : ''
        this.sugerencia = e.dato.sugerencia ? e.dato.sugerencia : ''
        this.nombre = this.nombreOrigen
        this.chat_log_id = e.dato.chat_log_id ? e.dato.chat_log_id : ''
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre) {
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (!this.motivo) {
        this.errormsg = 'Debes ingresar un motivo por el cuál no te gustó el mensaje'
        return
      }
      if (!this.sugerencia) {
        this.errormsg = 'Debes ingresar un sugerencia para una mejor respuesta'
        return
      }
      const dataToSend = {
        form: 'NegativeFeedbackForm',
        evento: 'sentClick',
        fields: {
          origen: 'chat_user',
          firstname: this.nombre,
          chat_log_id: this.chat_log_id,
          motivo: this.motivo,
          sugerencia: this.sugerencia
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'NegativeFeedbackForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form__field {
		margin-bottom: 7px;
}

.form-box-body {
	height: 365px;
}
</style>
